import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation } from "react-router";
import { useTabletMediaQuery } from "hooks/useTabletMediaQuery";
import { useMobileMediaQuery } from "hooks/useMobileMediaQuery";

export const MenuContext = createContext(undefined);
export const MenuConsumer = MenuContext.Consumer;

export type MenuMode = "hidden" | "collapsed" | "expanded";

interface ContextValue {
  menuMode: MenuMode;
  setMenuMode: Dispatch<SetStateAction<MenuMode>>;
}
export const MenuProvider = ({ children }) => {
  const [menuMode, setMenuMode] = useState<MenuMode>("expanded");
  const isMobile = useMobileMediaQuery();
  const isTablet = useTabletMediaQuery();
  const location = useLocation();

  useEffect(() => {
    setMenuMode(isTablet || isMobile ? "hidden" : "expanded");
  }, [isTablet, isMobile, location.pathname]);

  const value: ContextValue = useMemo(
    () => ({ menuMode, setMenuMode }),
    [menuMode],
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
export const useMenuContext = (): ContextValue => useContext(MenuContext);
